<template>
  <el-dialog
      v-el-drag-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="打印电阻内盒铭牌"
      class="materialCodeModal"
      width="500px"
      top="5vh">
    <!--    80*40-->
    <div id="labelSettings">
      <el-form :inline="true" label-width="120px">
        <el-form-item label="TYPE">
          <el-input v-model="printType"/>
        </el-form-item>
        <el-form-item label="POWER">
          <el-input v-model="printPower"/>
        </el-form-item>
        <el-form-item label="RESTSTANCE">
          <el-input v-model="printRest"/>
        </el-form-item>
        <el-form-item label="ERROR MARG IN">
          <el-input v-model="printErr"/>
        </el-form-item>
        <el-form-item label="DATE">
          <el-input v-model="printDate"/>
        </el-form-item>
        <el-form-item label="PCS">
          <el-input v-model="printPcs"/>
        </el-form-item>
        <el-form-item label="条码">
          <el-input v-model="barCodeText" @input="codeChange"/>
        </el-form-item>
      </el-form>
    </div>
    <el-divider/>
    <div id="labelContent">
      <table style="border: 0;" id="printMaterialBoxLabel1">
        <tr>
          <td style="text-align: center;border:0;" colspan="3">
            <span style="font-size: 15px;font-weight: bold">BRAKING RESISTOR</span></td>
        </tr>
        <tr>
          <td style="width: 1px;"/>
          <td style="font-size: 13px;font-weight: bold;">TYPE:{{printType}}</td>
          <td style="font-size: 13px;font-weight: bold;">POWER:{{printPower}}</td>
        </tr>
        <tr>
          <td/>
          <td style="font-size: 14px;font-family: 'Arial Narrow';font-weight: bold;letter-spacing: -0.5px;">RESTSTANCE:{{printRest}}</td>
          <td style="font-size: 13px;font-weight: bold;">ERROR MARG IN:{{printErr}}</td>
        </tr>
        <tr>
          <td/>
          <td style="font-size: 13px;font-weight: bold;">DATE:{{printDate}}</td>
          <td style="font-size: 13px;font-weight: bold;">PCS:{{printPcs}}</td>
        </tr>
        <tr>
          <td colspan="3" style="text-align: center;margin-top: 0;">
            <img style="max-width: 300px;" :id="(() => 'barCode1_'+productInfo.pkid)()"></td>
        </tr>
        <!--        <tr>-->
        <!--          <td colspan="3" style="text-align: center;font-size: 12px;font-weight: bold;">{{barCodeText}}</td>-->
        <!--        </tr>-->
      </table>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" v-print="printOption" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import JsBarcode from "jsbarcode";
  import moment from "moment";

  export default {
    data() {
      return {
        dialogVisible: false,
        printType: "",
        printPower: "",
        printRest: "",
        printErr: "",
        printDate: "",
        printPcs: "",
        productInfo: {},
        barCodeText: "",
        printOption: {
          id: "printMaterialBoxLabel1",
          preview: false,
          popTitle: "打印",
          previewPrintBtnLabel: "打印",
          clickMounted() {
          },
        },
      };
    },

    methods: {
      open(productInfo) {
        this.dialogVisible = true;
        this.productInfo = productInfo;

        if (this.productInfo.specification && this.productInfo.specification.includes("-")) {
          let temp = this.productInfo.specification.split("-");
          this.printType = temp[0];
          this.printPower = temp[1];

          if (temp.length > 2) {
            this.printRest = temp[2];
            if (temp.length > 3) {
              this.printRest = this.printRest + "-" + temp[3];
            }
            if (temp.length > 4) {
              this.printRest = this.printRest + "-" + temp[4];
            }
            if (temp[2].toUpperCase().includes("RJ")) {
              this.printErr = "5%";
            } else if (temp[2].toUpperCase().includes("RK")) {
              this.printErr = "10%";
            } else if (temp[2].toUpperCase().includes("RH")) {
              this.printErr = "3%";
            }
          }
        }

        this.printPcs = "1PCS";
        this.printDate = this.productInfo.planStartTime;
        this.barCodeText = moment(new Date()).format("YYYYMM") + "000";

        this.$nextTick(() => {
          document.getElementById("barCode1_" + this.productInfo.pkid).innerHTML = "";
          this.bindBarCode(this.barCodeText, this.productInfo.pkid);
        });
      },
      bindBarCode(row, id) {
        let text = row;
        new JsBarcode(document.getElementById("barCode1_" + id), row, {
          text: text,
          fontSize: 18,
          width: 4,
          height: 20,
          marginTop: 0,
          displayValue: true,
          fontOptions: "bold",
        });
      },
      codeChange() {
        // this.$nextTick(() => {
        document.getElementById("barCode1_" + this.productInfo.pkid).innerHTML = "";
        this.bindBarCode(this.barCodeText, this.productInfo.pkid);
        // });
      },

      print() {
        // this.printLoading = true;
        // document.body.innerHTML = document.getElementById("printMaterialBoxLabel").parentNode.innerHTML;
        // window.print();
        // window.location.reload();
        //
      },
    },
  };
</script>
<style lang="scss" scoped>
.materialCodeModal .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.materialCodeModal .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.materialCodeModal .el-dialog {
  //margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 39px;
  height: 90%;
}

.materialCodeModal .el-divider--horizontal {
  margin: 10px 0;
}

.materialCodeModal .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>

<style lang="scss" scoped>
#printMaterialBoxLabel1 {
  width: 80mm;
  height: 40mm;
  margin: 0 auto;
  //margin-top: 0.5mm;
  page-break-before: always;
  //font-size: 10px;
  line-height: 1 !important;

  table {
    width: 100%;
    height: 100%;

    td {
      border: 0px solid #111;
      //border-bottom: 0;
      //border-right: 0;
      //padding: 0;
      //box-sizing: border-box;
      //height: 6mm;
    }

    tr:first-child td:first-child {
      border-bottom: 0px solid #111;
    }

    tr:last-child td {
      border-bottom: 0px solid #111;
    }

    tr td:last-child {
      border-right: 0px solid #111;
    }
  }
}
</style>
